import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="tech-grid bg-navy-950 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yejliorx507r">
        <div className="text-center" data-id="element-22" data-mp="1ao7ah51dmncy">
          <span className="inline-flex items-center gap-2 rounded-md bg-sun-400 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-navy-950" data-id="element-23" data-mp="1ap8mbbq7vdvq">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jgisq3mc74hu" /> Incluidos sin costo extra
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-25" data-mp="1epiv0w5e8iea">
            Los {totalBonuses} Bonos Estratégicos
          </h2>
        </div>

        <div className="mt-10 grid gap-5" data-id="element-26" data-mp="qy3qqxu23r0e">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-6 rounded-xl border border-navy-700 bg-navy-800 p-6 sm:p-8 md:grid-cols-[220px_1fr]" data-id="element-27" data-mp="29r1mqwsi8en4" data-mpi={index}>
                <div className="flex items-start justify-between gap-4 md:flex-col md:justify-start" data-id="element-28" data-mp="1vsbsrq0zev2z">
                  <div className="flex items-center gap-3 md:flex-col md:items-start" data-id="element-29" data-mp="20reogjv2noya">
                    <span className="flex h-12 w-12 items-center justify-center rounded-md bg-leaf-500 text-white" data-id="element-30" data-mp="20trezlewb7my">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-31" data-mp="3c6tuse967t62" />
                    </span>
                    <p className="text-xs font-extrabold uppercase tracking-[.16em] text-navy-200" data-id="element-32" data-mp="3h5mwl9f3hvqe">Bono {bonus.number}</p>
                  </div>
                  <p className="text-right text-xs font-bold text-navy-200 md:text-left" data-id="element-33" data-mp="1h23x3kzdhtcf">
                    <span className="block line-through" data-id="element-34" data-mp="1c396hwv5z0hr">Valor real: {bonus.value}</span>
                    <span className="mt-2 inline-block rounded-md bg-sun-400 px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-navy-950" data-id="element-35" data-mp="1q4d96faahurx">
                      Gratis
                    </span>
                  </p>
                </div>

                <div className="flex flex-col" data-id="element-36" data-mp="yaji5ls5xjhh">
                  <h3 className="text-xl font-extrabold leading-tight text-white" data-id="element-37" data-mp="tevsz6dokqbz">{bonus.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-navy-100" data-id="element-38" data-mp="17699sck7fa3b">{bonus.description}</p>

                  {bonus.items && <ul className="mt-4 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-39" data-mp="12cehwlug3ot5">
                      {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-navy-50" data-id="element-40" data-mp="anl3mtnlslm7">
                          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-leaf-400" aria-hidden="true" data-id="element-41" data-mp="jo8for5s704" />
                          {item}
                        </li>)}
                    </ul>}

                  {bonus.note && <p className="mt-4 text-sm italic leading-relaxed text-navy-200" data-id="element-42" data-mp="3ms606izkjxmy">{bonus.note}</p>}

                  {bonus.benefit && <p className="mt-5 rounded-lg border-l-4 border-sun-400 bg-navy-900 px-4 py-3 text-sm font-semibold text-white" data-id="element-43" data-mp="j9w4xo0crz7c">
                      {bonus.benefit}
                    </p>}
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border-2 border-sun-400 bg-navy-900 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-44" data-mp="eaj9ievf1jt5">
          <div data-id="element-45" data-mp="2u41s5qtiz8h3">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-navy-200" data-id="element-46" data-mp="2z10kq4xjj7d6">
              Valor total de los {totalBonuses} bonos
            </p>
            <p className="mt-1 font-display text-2xl font-extrabold text-white line-through decoration-red-500 decoration-2" data-id="element-47" data-mp="3f9pzt5a7kgpj">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-48" data-mp="35j4y38z8mw2e">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-navy-200" data-id="element-49" data-mp="30jab3gil2qmm">Tu precio hoy</p>
            <p className="mt-1 inline-flex items-center gap-2 font-display text-3xl font-extrabold text-sun-400" data-id="element-50" data-mp="21d2zlpt1vzz">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-51" data-mp="3t7ekod49znul" /> GRATIS
            </p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-navy-200" data-id="element-52" data-mp="3o7tk5y9gj7fr">
          Solo incluidos en esta oferta.
        </p>
      </div>
    </section>;
}